import { createApp } from 'vue'
import App from './App.vue'
import vueI18n from '@/lang/index'

createApp(App).use(vueI18n).mount('#app')
